export const DASHBOARD = Object.freeze({
    ASSETS: 'assets',
    ANALYTICS: 'analytics'
  });